import type { CatalogProps } from '../index';

/** Lumina Cinema — vitrine (home). Réplica fiel de docs/prototype/lpplat/LP/code.html.
 *
 *  Entrega 1 (visual-first): conteúdo VERBATIM do protótipo ("Lumina / Tech Dry") — textos,
 *  preços e imagens remotas fixos. A fiação com os dados reais da loja (nome, cores, logo,
 *  catálogo publicado, toggles de seção) vem numa entrega seguinte; por isso `CatalogProps`
 *  é aceito mas ainda não consumido. RSC-safe: sem `'use client'`, sem hooks, só `<a>`.
 *
 *  Único desvio do protótipo: header vira `sticky` (não `fixed`) pra ficar contido na
 *  moldura de preview do Studio sem escapar pro viewport. */

const IMG = {
  hero: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDFe22dwb6dIJb19D56sYBqsKGWEqyB436C5LBleRu9V0bOkhPeekdBhX5C0ck4_m_0cj7uurtTm5qqrblBdFR0gM589BfrTqWJDbGS3Tc8M6DemAASpDNeoZF7KU_3H2ayLXjl5Ffj9GacGMdS9jBCexDGauOiEyiwHEkUE9yfQpFA27HRMEfLz6Z1RJgJfp_wO_iWl34eKEp_S8mI7JCeBYU5lqGJ2X48FhqTpfxL-A1ibgtnR0nk5w',
  cat1: 'https://lh3.googleusercontent.com/aida-public/AB6AXuB-L0ujNL5Qb2jpvPVE9UbVIML4ugS6baCx6k4LqIa1HTztQQl6YPAsg2Ehwq5sxGS6g4bKIy_RC02DDpCsguckuYEU92IGo00_CimUdnj7P_MVDteDDvcCqLJSWU-SB96srz8rhohlPyI6-vADu4dFTpAblhv0IN_PlSWh78tFlBRMfTbAOtD1BI_-Pr2olZdxFrH5mHEIAXxhJVVUO0GeZxaCaiPgM7TCh1TMy09gWkE5zF4AlCHNkw',
  cat2: 'https://lh3.googleusercontent.com/aida-public/AB6AXuApPDI2titwPBlbJNL5nDg88_IWIcoH36J6VU5ARBaFjZD1WSucuKKCFkGysWlNZnckg1qw1LJf9s8U9Au6dxHNSppTE3E-j5-zCLqCv2YYoHi0PXfHVk4gtT6yUZzMfAFxuJyVVUICTDxki2OUh72DMePm1CdfT2-u_dhsoZ7TELaXa_HeeFibDnGXlJ0Pm-hNwpTLhRr4q1fF21tulv4DhsjLofYvkzj2Msiy9-zAm6EsjtED2kRCjA',
  cat3: 'https://lh3.googleusercontent.com/aida-public/AB6AXuADEt1ADou46aR020KVQPj5bgKaOVaPA88mVEUHEzG8t-7qBfzk0iokmNWaPEH8UIKhLNxKT-w9ogpAkofjv2x6OglCvbNFQxDAjRGXdjCnbaj50C3nATZrTUorvPbcXfgLfdxelzr_aEx5sIRRSl-j5vXN0Hx9ZMxc6CWEra7YonXFquu0xcyyvycwjwT9KaZfBKxoLQNjOGRYjPbg9Dr1KOh2skiRZ63MKTquf95C8G14dy5EKXBcKQ',
  prod1:
    'https://lh3.googleusercontent.com/aida-public/AB6AXuC-nmhZ2h-snnYH6C9XAKN1Fh2IgZ4WhdMA3tEC9Xj5SknG54X1GvRsCKhUu6pB0XYarHdodbYTTzw6gbr9gTkZjScf8FuPx0CI7swfgfkO6wNgTG4iZ3bbqysHximI3dUcRB5TNRbMdC2vZ4QZP_NUP89RXylqQbDsE-6vCvOlC7ixArlndrSYM24z7T4EOd-OT0GfWm23qGY635VGPjYmNOWQ3F4_0bZI73tyW-LPmM1ycwBaMstm0A',
  prod2:
    'https://lh3.googleusercontent.com/aida-public/AB6AXuAy-tt_k_okYEwvOYL831DsxFDx-0GmMbS_tAfq_XHUfDjiu9invLAtoIk_64NcVMjqxRw3HykNnUeBBaIOVLtm4evyOZYGS4Uev6FOwYwHXeEGmrAZ3NpTkiiunSFlHcOxjwdbUDUv0YZMeHCNkKlFDfTKiCz5Nd58N8umWTiUF3NzjL3odXqOUBa3Tl0P3aMYiEezNbAzLScieJPYELAHM9hoLFG_0pQHVuYk3HcDtAVFAIiVFGISnA',
  prod3:
    'https://lh3.googleusercontent.com/aida-public/AB6AXuDeD0N2VDjAvP4s-S7b0Ku5-fwDXIMMgC5zSOuaSKChm0zoxPbbq0fQOKKTxVkESeoQyAKaHeAcaitSkjCyp0SK-QMiheVFik7yadz7BjlCmxWMZIpOIUS6NvRouxpLsMAot2WMF9yFLo8gfly-iRZmi90sHkSKec2xYcbThf1c42-x3xoeG3j8nezHCodTVjSwvBg4Or8uYkYKvTCIIBMxQvvlZ6EAwDo9R3buuo3bztAzxtx_OrrYPA',
  prod4:
    'https://lh3.googleusercontent.com/aida-public/AB6AXuC06t0xSbE25a7HHDU7B0ZM0Mj35bh8mM_oGp97ZlcaeqjQ_YQYnA6NswlRCu7KuVeAQDzFRdaIXBZPoG1mFPmmcdETjV5oWXegvvoYCsfNe7JyKVw9mvx8BNRtxMD2l6PalqPRYwhOVyumH72y-ybxKw8erDelTltIC45VuHP8h5Mm5sCqruaSbl__60HD1c5Gd4JngXmPDy5CoZP2oyLf0sqe10wOgEyn0D6fBCPxYigaSubMTw0qsA',
  lab: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCf_ZczSjYClvafWWz9Ixn544IgiGmIaFJ0JNM-wKyM7ZsWi9ALE8teXYB8Y-jP1SM0wzgo48gGzl3DW9NvVMhSeQuJqZ0rERiyPGG5m-utcbx32B6ozu-zVWx-WeyraS1xqHyivLLkRST_d8pH4c-ciLY8XBhXOJJ3ao1v9dH9O225nIz0_LiVgxhApZyUtoYhhNdKef268-4ASxHUTeHMAzEwS6NHlTsvEGqbEcJ-88bDuUpUpf8FQw',
  face1:
    'https://lh3.googleusercontent.com/aida-public/AB6AXuD0szePDCLJGkFjBIYxGleI61UkHvPfbtF2eXKcmh0luo3-HMT5yLcuZTxJhDxnDotA33AuGLRHq1XSQVgXT9CaYhcsZgjXkWCMDJa-phuMyXf5B5CCQmLN2z1w2O6Pq_Te8gQ5PnixrcyBGxl8FwrzbKMyDpjjlnA4EtDblMPcCt0sJRek_7I2HSprs-M5CK6Z7jCGvZZjBZoiBUwaTbuT5nmxozUKjjcxxGc5dSiKbjXSxHxZKwwd5A',
  face2:
    'https://lh3.googleusercontent.com/aida-public/AB6AXuA0l1lrpScOLosLdcV6UoWcVJ5l-BP1l4koiebWaus_-TQvVxKZzBsYlQfcMFBQspLO52q30pdmFCGeHjlk7hzIAP3jEUQWDiGRH2tSMhc9JA8LNVPr92yu_qKUKxfetjC4tOAXC4B-EcE7nPQQQtJOeE5K7aY2dSCivmXugYTkAH-LszmEN47_wclOnlKF2ypagh0t38RCowBowdcRAhoSebaUXyIVwK_LN1hqAVW6Ha4ie31nO06UWg',
  face3:
    'https://lh3.googleusercontent.com/aida-public/AB6AXuAAbvvToLTZPqvNZeumHFdJ2E8YVEUo4Vrkos7TYiIvGQuWG38WdBQcWPz3AsiMcHhJCofUJWW5a1VIPOmNpJbttX13F4PvSh8rWmZ16GtYUckCVjvTcKD8ydC3lUmqaCCcoUp0v5Go1v9aEP4dStjiP-jwOuCUnRAaOt8aZBiUCXHknSbkskY8k4mwKtt19IHk3LYUlYmG_MeDFVabnjeueXF5WVurkVbO5FyT4hG4zFILtLLbeiLVYw',
} as const;

function Sym({ name, className }: { name: string; className?: string }) {
  return <span className={`material-symbols-outlined ${className ?? ''}`}>{name}</span>;
}

function Metric({
  icon,
  tone,
  stat,
  caption,
}: {
  icon: string;
  tone: 'primary' | 'secondary';
  stat: string;
  caption: string;
}) {
  return (
    <div className="flex items-center gap-space-sm">
      <div
        className={`w-10 h-10 rounded-xl bg-surface-container-high flex items-center justify-center ${tone === 'primary' ? 'text-primary' : 'text-secondary'}`}
      >
        <Sym name={icon} className="text-[20px]" />
      </div>
      <div>
        <span className="font-metric-stat text-headline-sm text-on-surface block">{stat}</span>
        <span className="font-body-sm text-body-sm text-on-surface-variant">{caption}</span>
      </div>
    </div>
  );
}

function CategoryCard({
  img,
  badge,
  badgeCls,
  title,
  body,
}: {
  img: string;
  badge: string;
  badgeCls: string;
  title: string;
  body: string;
}) {
  return (
    <a
      href="#"
      className="group relative rounded-2xl overflow-hidden h-[420px] bg-surface-container-low flex flex-col justify-end p-space-xl transition-all duration-300 shadow-xl hover:-translate-y-1 hover:shadow-2xl"
    >
      <div
        className="absolute inset-0 bg-cover bg-center group-hover:scale-105 transition-transform duration-700"
        style={{ backgroundImage: `url('${img}')` }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-surface-container-lowest via-surface-container-lowest/50 to-transparent" />
      <div className="relative z-10 space-y-space-xs">
        <span
          className={`px-space-xs py-space-3xs rounded-full font-label-sm text-label-sm ${badgeCls}`}
        >
          {badge}
        </span>
        <h3 className="font-headline-md text-headline-md text-on-surface group-hover:text-primary transition-colors">
          {title}
        </h3>
        <p className="font-body-sm text-body-sm text-on-surface-variant">{body}</p>
        <div className="pt-space-xs flex items-center gap-space-2xs text-secondary font-label-md text-label-md">
          <span>Acessar Categoria</span>
          <Sym
            name="arrow_forward"
            className="text-[16px] group-hover:translate-x-1 transition-transform"
          />
        </div>
      </div>
    </a>
  );
}

function ProductCard({
  img,
  badge,
  badgeCls,
  rating,
  reviews,
  name,
  desc,
  price,
  cents,
  pix,
  installments,
  primary,
}: {
  img: string;
  badge: string;
  badgeCls: string;
  rating: string;
  reviews: string;
  name: string;
  desc: string;
  price: string;
  cents: string;
  pix: string;
  installments: string;
  primary?: boolean;
}) {
  return (
    <div
      className="group bg-surface-container-low rounded-2xl p-space-md flex flex-col justify-between shadow-lg hover:shadow-2xl transition-all duration-300"
      id={primary ? 'produto-destaque' : undefined}
    >
      <div className="relative w-full h-72 rounded-xl overflow-hidden bg-surface-container-lowest mb-space-md">
        <img
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          src={img}
          alt=""
        />
        <div className="absolute top-3 left-3 flex flex-col gap-space-2xs">
          <span
            className={`px-space-xs py-space-3xs rounded-md font-label-sm text-label-sm font-bold shadow-md ${badgeCls}`}
          >
            {badge}
          </span>
          <span className="px-space-xs py-space-3xs rounded-md bg-surface-container-high/90 backdrop-blur-md text-primary font-label-sm text-label-sm">
            PIX Instantâneo D+0
          </span>
        </div>
        <button
          type="button"
          aria-label="Favoritar"
          className="absolute bottom-3 right-3 w-9 h-9 rounded-full bg-surface-container-high/80 backdrop-blur-md text-on-surface flex items-center justify-center hover:bg-primary hover:text-on-primary transition-colors"
        >
          <Sym name="favorite" className="text-[18px]" />
        </button>
      </div>
      <div className="space-y-space-xs flex-1 flex flex-col justify-between">
        <div>
          <div className="flex items-center gap-space-2xs text-secondary mb-space-3xs">
            <Sym name="star" className="text-[14px]" />
            <span className="font-label-sm text-label-sm font-bold">{rating}</span>
            <span className="text-outline text-label-sm">({reviews} avaliações)</span>
          </div>
          <h3 className="font-headline-sm text-headline-sm text-on-surface">{name}</h3>
          <p className="font-body-sm text-body-sm text-on-surface-variant line-clamp-2">{desc}</p>
        </div>
        <div className="pt-space-md space-y-space-md">
          <div className="flex items-baseline justify-between">
            <div>
              <span className="font-metric-stat text-headline-sm text-on-surface">
                {price}
                <span className="text-body-sm">{cents}</span>
              </span>
              <span className="block font-label-sm text-label-sm text-secondary">{pix}</span>
            </div>
            <span className="font-label-sm text-label-sm text-outline">{installments}</span>
          </div>
          <a
            href="#"
            className={`w-full py-space-sm rounded-xl font-label-md text-label-md font-bold flex items-center justify-center gap-space-xs transition-all ${
              primary
                ? 'bg-primary text-on-primary shadow-md hover:shadow-[0_0_16px_rgba(192,193,255,0.4)]'
                : 'bg-surface-container-highest text-on-surface hover:bg-primary hover:text-on-primary'
            }`}
          >
            <Sym name="shopping_cart_checkout" className="text-[18px]" />
            <span>Ver Detalhes / Comprar</span>
          </a>
        </div>
      </div>
    </div>
  );
}

function Testimonial({
  quote,
  photo,
  name,
  role,
}: {
  quote: string;
  photo: string;
  name: string;
  role: string;
}) {
  return (
    <div className="p-space-xl rounded-2xl bg-surface-container-low shadow-lg flex flex-col justify-between space-y-space-md">
      <div className="space-y-space-xs">
        <div className="flex items-center gap-space-3xs text-secondary">
          {Array.from({ length: 5 }).map((_, i) => (
            <Sym key={i} name="star" className="text-[18px]" />
          ))}
        </div>
        <p className="font-body-md text-body-md text-on-surface italic">{quote}</p>
      </div>
      <div className="flex items-center gap-space-sm pt-space-xs">
        <img className="w-12 h-12 rounded-full object-cover" src={photo} alt="" />
        <div>
          <h4 className="font-label-lg text-label-lg text-on-surface">{name}</h4>
          <span className="font-body-sm text-body-sm text-outline">{role}</span>
        </div>
      </div>
    </div>
  );
}

export default function Catalog(_props: CatalogProps) {
  return (
    <div className="lumina bg-background font-body-md text-on-surface antialiased">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-surface/80 backdrop-blur-xl shadow-[0_1px_8px_rgba(0,0,0,0.04)]">
        <div className="h-20 max-w-7xl mx-auto px-grid-margin-desktop flex items-center justify-between gap-space-lg">
          <div className="flex items-center gap-space-xl">
            <a className="flex items-center gap-space-xs" href="#">
              <div className="w-9 h-9 rounded-lg bg-surface-container-highest flex items-center justify-center">
                <Sym name="storefront" className="text-primary text-[22px]" />
              </div>
              <span className="font-headline-sm text-headline-sm text-on-surface tracking-tight font-bold">
                STOREO
              </span>
            </a>
            <nav className="hidden lg:flex items-center gap-space-lg">
              <a aria-current="page" className="transition-colors text-primary font-bold" href="#">
                Início
              </a>
              <a
                className="font-label-lg text-label-lg text-on-surface-variant hover:text-on-surface transition-colors"
                href="#"
              >
                Coleções
              </a>
              <a
                className="font-label-lg text-label-lg text-on-surface-variant hover:text-on-surface transition-colors"
                href="#"
              >
                Cursos &amp; Digitais
              </a>
              <a
                className="font-label-lg text-label-lg text-on-surface-variant hover:text-on-surface transition-colors"
                href="#"
              >
                Lançamentos
              </a>
            </nav>
          </div>
          <div className="flex items-center gap-space-md">
            <button
              type="button"
              aria-label="Buscar no catálogo"
              className="w-10 h-10 rounded-full flex items-center justify-center bg-surface-container-low hover:bg-surface-container hover:text-on-surface text-on-surface-variant transition-colors"
            >
              <Sym name="search" className="text-[20px]" />
            </button>
            <a
              className="hidden sm:flex items-center gap-space-xs px-space-md py-space-xs rounded-full bg-surface-container-low hover:bg-surface-container text-on-surface transition-colors"
              href="#"
            >
              <Sym name="school" className="text-secondary text-[18px]" />
              <span className="font-label-md text-label-md">Área do Aluno / Cliente</span>
            </a>
            <button
              type="button"
              aria-label="Carrinho de compras"
              className="relative flex items-center justify-center w-10 h-10 rounded-full bg-surface-container-low hover:bg-surface-container text-on-surface transition-colors"
            >
              <Sym name="shopping_bag" className="text-[20px]" />
              <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-secondary text-on-secondary flex items-center justify-center font-label-sm text-label-sm font-bold shadow-[0_0_12px_rgba(78,222,163,0.4)]">
                3
              </span>
            </button>
            <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center">
              <Sym name="person" className="text-on-primary text-[18px]" />
            </div>
          </div>
        </div>
      </header>

      <main className="w-full bg-background">
        <div className="flex flex-col w-full">
          {/* Announcement ticker */}
          <div className="w-full bg-surface-container-lowest text-secondary py-space-xs px-grid-margin-desktop shadow-sm flex items-center justify-between overflow-hidden">
            <div className="flex items-center gap-space-sm mx-auto animate-pulse">
              <Sym name="bolt" className="text-[16px]" />
              <span className="font-label-sm text-label-sm tracking-widest uppercase">
                Frete Grátis acima de R$ 199 + Envio Expresso em 24h • Use o cupom{' '}
                <span className="text-on-surface bg-surface-container-high px-space-xs py-space-3xs rounded">
                  LUMINA10
                </span>{' '}
                na finalização
              </span>
            </div>
            <div className="hidden xl:flex items-center gap-space-xs font-label-sm text-label-sm text-outline">
              <span className="inline-block w-2 h-2 rounded-full bg-secondary" />
              <span>Liquidação Instantânea Pix SPI BACEN 24/7</span>
            </div>
          </div>

          {/* Hero */}
          <section className="relative w-full overflow-hidden bg-surface-container-lowest">
            <div className="absolute inset-0 z-0">
              <div
                className="w-full h-full bg-cover bg-center opacity-40 scale-105 transition-transform duration-1000"
                style={{ backgroundImage: `url('${IMG.hero}')` }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-transparent" />
              <div className="absolute -top-32 right-10 w-96 h-96 bg-primary/10 rounded-full blur-3xl pointer-events-none" />
              <div className="absolute bottom-10 left-10 w-80 h-80 bg-secondary/10 rounded-full blur-3xl pointer-events-none" />
            </div>
            <div className="relative z-10 max-w-7xl mx-auto px-grid-margin-desktop pt-28 md:pt-32 pb-space-3xl flex flex-col justify-end min-h-[680px] md:min-h-[780px]">
              <div className="max-w-3xl space-y-space-lg">
                <div className="inline-flex items-center gap-space-xs px-space-sm py-space-2xs rounded-full bg-surface-container-high/80 backdrop-blur-md">
                  <Sym name="verified" className="text-secondary text-[16px]" />
                  <span className="font-label-sm text-label-sm tracking-wider uppercase text-on-surface">
                    Coleção Cápsula 2025 // Performance Dry
                  </span>
                </div>
                <h1 className="font-display-xl text-display-xl text-on-surface tracking-tight leading-none">
                  Minimalist Tech Dry.
                  <br />
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-on-surface via-primary to-secondary">
                    Performance Pura.
                  </span>
                </h1>
                <p className="font-body-lg text-body-lg text-on-surface-variant max-w-xl leading-relaxed">
                  Engenharia têxtil com nanopartículas antibacterianas, regulação térmica contínua e
                  corte angular projetado para mobilidade de alta precisão.
                </p>
                <div className="flex flex-wrap items-center gap-space-md pt-space-xs">
                  <a
                    className="px-space-xl py-space-md rounded-xl bg-primary text-on-primary font-label-lg text-label-lg shadow-xl hover:shadow-[0_0_24px_rgba(192,193,255,0.4)] transition-all flex items-center gap-space-xs"
                    href="#destaques"
                  >
                    <span>Explorar Coleção</span>
                    <Sym name="arrow_forward" className="text-[18px]" />
                  </a>
                  <a
                    className="px-space-xl py-space-md rounded-xl bg-surface-container-high text-on-surface font-label-lg text-label-lg hover:bg-surface-bright transition-colors flex items-center gap-space-xs"
                    href="#produto-destaque"
                  >
                    <Sym name="local_fire_department" className="text-secondary text-[18px]" />
                    <span>Ver Oferta Principal</span>
                  </a>
                  <div className="flex items-center gap-space-sm ml-auto text-on-surface-variant font-label-sm text-label-sm">
                    <Sym name="schedule" className="text-secondary text-[20px]" />
                    <span>Lote limitado: Restam 24 peças em estoque</span>
                  </div>
                </div>
              </div>

              {/* Metrics ribbon */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-space-md mt-space-3xl pt-space-xl bg-surface-container-low/70 backdrop-blur-xl rounded-2xl p-space-lg shadow-2xl">
                <Metric
                  icon="water_drop"
                  tone="secondary"
                  stat="0.3s"
                  caption="Secagem hidrofóbica"
                />
                <Metric
                  icon="thermostat"
                  tone="primary"
                  stat="-3.2°C"
                  caption="Conforto térmico ativo"
                />
                <Metric
                  icon="format_image_left"
                  tone="secondary"
                  stat="30 Dias"
                  caption="Garantia incondicional"
                />
                <Metric
                  icon="qr_code_2"
                  tone="primary"
                  stat="Pix SPI"
                  caption="Liberação imediata D+0"
                />
              </div>
            </div>
          </section>

          {/* Bento category showcase */}
          <section className="w-full py-space-3xl max-w-7xl mx-auto px-grid-margin-desktop">
            <div className="flex flex-col md:flex-row md:items-end justify-between mb-space-2xl gap-space-md">
              <div>
                <div className="inline-flex items-center gap-space-2xs text-secondary font-label-sm text-label-sm uppercase tracking-wider mb-space-2xs">
                  <Sym name="grid_view" className="text-[14px]" /> Linhas Estratégicas
                </div>
                <h2 className="font-headline-lg text-headline-lg text-on-surface">
                  Arquitetura de Produtos 2025
                </h2>
              </div>
              <p className="font-body-md text-body-md text-on-surface-variant max-w-md">
                Equipamentos e vestuário concebidos para executivos, criadores de conteúdo e atletas
                urbanos que não admitem concessões.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-space-lg">
              <CategoryCard
                img={IMG.cat1}
                badge="8 Peças Ativas"
                badgeCls="bg-secondary/20 text-secondary"
                title="Vestuário Inteligente"
                body="Cortes ergonômicos, nanotecnologia têxtil e acabamento impermeável matte."
              />
              <CategoryCard
                img={IMG.cat2}
                badge="Edição Limitada"
                badgeCls="bg-primary/20 text-primary"
                title="Hardware & Gadgets"
                body="Cancelamento de ruído premium, sensores térmicos e conectividade low-latency."
              />
              <CategoryCard
                img={IMG.cat3}
                badge="Usinagem Aeroespacial"
                badgeCls="bg-surface-container-high text-on-surface"
                title="Acessórios EDC"
                body="Titânio grau 5, bloqueio RFID absoluto e design monolítico ultra-fino."
              />
            </div>
          </section>

          {/* Featured products grid */}
          <section className="w-full py-space-3xl bg-surface-container-lowest" id="destaques">
            <div className="max-w-7xl mx-auto px-grid-margin-desktop">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-space-md mb-space-2xl">
                <div>
                  <div className="inline-flex items-center gap-space-2xs text-secondary font-label-sm text-label-sm uppercase tracking-wider mb-space-2xs">
                    <Sym name="stars" className="text-[16px]" /> Seleção de Precisão
                  </div>
                  <h2 className="font-headline-lg text-headline-lg text-on-surface">
                    Produtos Principais &amp; Disponibilidade
                  </h2>
                </div>
                <div className="flex items-center gap-space-xs bg-surface-container-low p-space-2xs rounded-xl">
                  <button
                    type="button"
                    className="px-space-md py-space-xs rounded-lg bg-surface-container-highest text-on-surface font-label-sm text-label-sm"
                  >
                    Todos
                  </button>
                  <button
                    type="button"
                    className="px-space-md py-space-xs rounded-lg text-on-surface-variant hover:text-on-surface font-label-sm text-label-sm transition-colors"
                  >
                    Mais Vendidos
                  </button>
                  <button
                    type="button"
                    className="px-space-md py-space-xs rounded-lg text-on-surface-variant hover:text-on-surface font-label-sm text-label-sm transition-colors"
                  >
                    Pronta Entrega
                  </button>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-space-lg">
                <ProductCard
                  primary
                  img={IMG.prod1}
                  badge="Mais Vendido"
                  badgeCls="bg-secondary text-on-secondary"
                  rating="4.9"
                  reviews="342"
                  name="Camiseta Tech Dry"
                  desc="Tecido hidrofóbico respirável, antimicrobiano com corte slim angular."
                  price="R$ 249"
                  cents=",90"
                  pix="R$ 224,91 no Pix (10% OFF)"
                  installments="3x de R$ 83,30"
                />
                <ProductCard
                  img={IMG.prod2}
                  badge="Sensor LED"
                  badgeCls="bg-tertiary-container text-on-tertiary-container"
                  rating="4.8"
                  reviews="188"
                  name="Smart Hydration Flask 750ml"
                  desc="Isolamento a vácuo 24h gelado com display touch de temperatura e esterilização UV-C."
                  price="R$ 389"
                  cents=",00"
                  pix="R$ 350,10 no Pix (10% OFF)"
                  installments="4x de R$ 97,25"
                />
                <ProductCard
                  img={IMG.prod3}
                  badge="RFID Shield"
                  badgeCls="bg-surface-container-high/90 backdrop-blur-md text-on-surface"
                  rating="5.0"
                  reviews="512"
                  name="Carteira Slim Titânio Carbon"
                  desc="Comporta até 12 cartões, clipe de notas em titânio e blindagem contra furto sem contato."
                  price="R$ 299"
                  cents=",00"
                  pix="R$ 269,10 no Pix (10% OFF)"
                  installments="3x de R$ 99,66"
                />
                <ProductCard
                  img={IMG.prod4}
                  badge="Áudio Espacial"
                  badgeCls="bg-secondary text-on-secondary"
                  rating="4.9"
                  reviews="96"
                  name="Earbuds Lumina ANC Pro"
                  desc="Cancelamento ativo híbrido de -42dB, drivers de grafeno e autonomia de 38 horas totais."
                  price="R$ 599"
                  cents=",00"
                  pix="R$ 539,10 no Pix (10% OFF)"
                  installments="6x de R$ 99,83"
                />
              </div>
            </div>
          </section>

          {/* Philosophy / pillars */}
          <section className="w-full py-space-3xl relative overflow-hidden bg-background">
            <div className="max-w-7xl mx-auto px-grid-margin-desktop">
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-space-2xl items-center">
                <div className="lg:col-span-7 space-y-space-lg">
                  <div className="inline-flex items-center gap-space-2xs text-primary font-label-sm text-label-sm uppercase tracking-wider">
                    <Sym name="precision_manufacturing" className="text-[16px]" /> Filosofia de
                    Engenharia
                  </div>
                  <h2 className="font-headline-lg text-headline-lg text-on-surface tracking-tight">
                    Construído para resistir à obsolescência programada.
                  </h2>
                  <p className="font-body-lg text-body-lg text-on-surface-variant leading-relaxed">
                    A Lumina Studio nasceu da convergência entre o design funcional brutalista e
                    materiais aeroespaciais. Não fabricamos modismos; desenvolvemos utilitários
                    duráveis que eliminam o atrito do seu dia a dia profissional e urbano.
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-space-md pt-space-xs">
                    <div className="p-space-md rounded-xl bg-surface-container-low shadow-md space-y-space-2xs">
                      <div className="w-8 h-8 rounded-lg bg-surface-container-high flex items-center justify-center text-secondary">
                        <Sym name="verified_user" className="text-[18px]" />
                      </div>
                      <h4 className="font-label-lg text-label-lg text-on-surface">
                        30 Dias de Prova Real
                      </h4>
                      <p className="font-body-sm text-body-sm text-on-surface-variant">
                        Se a modelagem ou ergonomia não superarem seu padrão, devolvemos 100% do
                        valor imediatamente.
                      </p>
                    </div>
                    <div className="p-space-md rounded-xl bg-surface-container-low shadow-md space-y-space-2xs">
                      <div className="w-8 h-8 rounded-lg bg-surface-container-high flex items-center justify-center text-primary">
                        <Sym name="local_shipping" className="text-[18px]" />
                      </div>
                      <h4 className="font-label-lg text-label-lg text-on-surface">
                        Despacho Expresso 24h
                      </h4>
                      <p className="font-body-sm text-body-sm text-on-surface-variant">
                        Hub logístico central com rastreamento ativo em tempo real via WhatsApp e
                        SMS.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="lg:col-span-5 relative">
                  <div className="relative w-full h-[480px] rounded-2xl overflow-hidden bg-surface-container-low shadow-2xl">
                    <img className="w-full h-full object-cover" src={IMG.lab} alt="" />
                    <div className="absolute inset-0 bg-gradient-to-t from-surface-container-lowest/90 via-transparent to-transparent" />
                    <div className="absolute bottom-6 left-6 right-6 p-space-md rounded-xl bg-surface-container-high/80 backdrop-blur-md">
                      <div className="flex items-center justify-between">
                        <div>
                          <span className="font-label-sm text-label-sm text-secondary uppercase tracking-wider block">
                            Certificação Têxtil
                          </span>
                          <span className="font-headline-sm text-headline-sm text-on-surface">
                            Nano-Tech Weave 4.0
                          </span>
                        </div>
                        <Sym name="verified" className="text-secondary text-[28px]" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Testimonials */}
          <section className="w-full py-space-3xl bg-surface-container-lowest">
            <div className="max-w-7xl mx-auto px-grid-margin-desktop">
              <div className="text-center max-w-2xl mx-auto mb-space-2xl space-y-space-2xs">
                <div className="inline-flex items-center gap-space-2xs text-secondary font-label-sm text-label-sm uppercase tracking-wider">
                  <Sym name="reviews" className="text-[16px]" /> Validação Real
                </div>
                <h2 className="font-headline-lg text-headline-lg text-on-surface">
                  Aprovado por quem exige o ápice
                </h2>
                <p className="font-body-md text-body-md text-on-surface-variant">
                  Mais de 14.800 pedidos entregues com índice de aprovação de 99.4% no ecossistema
                  Lumina.
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-space-lg">
                <Testimonial
                  quote={
                    '"A Camiseta Tech Dry mudou completamente minhas viagens de trabalho. Não amassa na mochila, seca em minutos após o treino e o visual minimalista é impecável em qualquer reunião."'
                  }
                  photo={IMG.face1}
                  name="Rafael Albuquerque"
                  role="Diretor de Tecnologia • São Paulo, SP"
                />
                <Testimonial
                  quote={
                    '"O acabamento da carteira de titânio é cirúrgico. Comprei via Pix, a confirmação foi instantânea e recebi o código de rastreio em menos de 4 horas. Padrão internacional de serviço."'
                  }
                  photo={IMG.face2}
                  name="Camila Sampaio"
                  role="Arquiteta & Urbanista • Curitiba, PR"
                />
                <Testimonial
                  quote={
                    '"Além dos produtos físicos serem espetaculares, o acesso à Área do Aluno com os mini-cursos de ergonomia e alta performance agrega um valor que nenhuma outra marca entrega."'
                  }
                  photo={IMG.face3}
                  name="Lucas Vasconcelos"
                  role="Founder • Belo Horizonte, MG"
                />
              </div>
            </div>
          </section>

          {/* VIP club CTA */}
          <section className="w-full py-space-3xl max-w-7xl mx-auto px-grid-margin-desktop">
            <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-surface-container-high via-surface-container to-surface-container-lowest p-space-2xl shadow-2xl">
              <div className="absolute -right-16 -top-16 w-80 h-80 rounded-full bg-primary/10 blur-3xl pointer-events-none" />
              <div className="absolute -left-16 -bottom-16 w-80 h-80 rounded-full bg-secondary/10 blur-3xl pointer-events-none" />
              <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-space-xl items-center">
                <div className="lg:col-span-8 space-y-space-sm">
                  <span className="px-space-xs py-space-3xs rounded-md bg-secondary/20 text-secondary font-label-sm text-label-sm uppercase tracking-wider inline-block">
                    Privilégios para Membros
                  </span>
                  <h2 className="font-headline-lg text-headline-lg text-on-surface">
                    Ingresse no Clube VIP Lumina
                  </h2>
                  <p className="font-body-md text-body-md text-on-surface-variant max-w-xl">
                    Tenha acesso antecipado a drops de edição limitada com 48 horas de
                    exclusividade, descontos automáticos de 15% em todas as compras e conteúdo de
                    alta performance na sua Área do Cliente.
                  </p>
                  <div className="flex flex-wrap items-center gap-space-md pt-space-xs text-on-surface font-label-sm text-label-sm">
                    <span className="flex items-center gap-space-2xs">
                      <Sym name="check_circle" className="text-secondary text-[16px]" />
                      Drops Sem Fila
                    </span>
                    <span className="flex items-center gap-space-2xs">
                      <Sym name="check_circle" className="text-secondary text-[16px]" />
                      Cashback D+0 em Pix
                    </span>
                    <span className="flex items-center gap-space-2xs">
                      <Sym name="check_circle" className="text-secondary text-[16px]" />
                      Suporte Concierge
                    </span>
                  </div>
                </div>
                <div className="lg:col-span-4">
                  <form className="space-y-space-xs bg-surface-container-low/90 backdrop-blur-md p-space-lg rounded-2xl shadow-xl">
                    <label
                      className="block font-label-sm text-label-sm text-on-surface font-semibold"
                      htmlFor="vip-email"
                    >
                      Receba o convite de entrada:
                    </label>
                    <input
                      className="w-full h-11 px-space-md rounded-xl bg-surface-container-lowest text-on-surface placeholder:text-outline text-body-sm focus:outline-none focus:ring-2 focus:ring-primary"
                      id="vip-email"
                      placeholder="seu.melhor@email.com"
                      type="email"
                    />
                    <button
                      type="button"
                      className="w-full py-space-sm rounded-xl bg-secondary text-on-secondary font-label-md text-label-md font-bold hover:shadow-[0_0_20px_rgba(78,222,163,0.4)] transition-all flex items-center justify-center gap-space-2xs"
                    >
                      <span>Ativar Meu Acesso VIP</span>
                      <Sym name="lock_open" className="text-[18px]" />
                    </button>
                    <span className="block text-center font-label-sm text-label-sm text-outline">
                      Sem spam. Cancele sua inscrição quando desejar.
                    </span>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="w-full bg-surface-container-lowest text-on-surface-variant mt-space-3xl">
        <div className="max-w-7xl mx-auto px-grid-margin-desktop py-space-3xl">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-space-2xl mb-space-2xl">
            <div className="space-y-space-md">
              <div className="flex items-center gap-space-xs">
                <div className="w-8 h-8 rounded-lg bg-surface-container-high flex items-center justify-center">
                  <Sym name="storefront" className="text-primary text-[18px]" />
                </div>
                <span className="font-headline-sm text-headline-sm text-on-surface font-bold">
                  STOREO
                </span>
              </div>
              <p className="font-body-sm text-body-sm text-on-surface-variant max-w-xs">
                Plataforma de comércio eletrônico white-label integrada com aceleração instantânea
                de pagamentos e ecossistema de conteúdo para membros.
              </p>
              <div className="flex items-center gap-space-xs pt-space-xs">
                <Sym name="verified" className="text-secondary text-[18px]" />
                <span className="font-label-sm text-label-sm text-secondary uppercase tracking-wider">
                  Operação Segura SPI Bacen
                </span>
              </div>
            </div>
            <div>
              <h4 className="font-label-lg text-label-lg text-on-surface mb-space-md">
                Catálogo &amp; Acesso
              </h4>
              <ul className="space-y-space-sm font-body-sm text-body-sm">
                <li>
                  <a
                    className="text-on-surface-variant hover:text-on-surface transition-colors"
                    href="#"
                  >
                    Todas as Coleções
                  </a>
                </li>
                <li>
                  <a
                    className="text-on-surface-variant hover:text-on-surface transition-colors"
                    href="#"
                  >
                    Cursos &amp; Mentorias
                  </a>
                </li>
                <li>
                  <a
                    className="text-on-surface-variant hover:text-on-surface transition-colors"
                    href="#"
                  >
                    Lançamentos Exclusivos
                  </a>
                </li>
                <li>
                  <a
                    className="text-on-surface-variant hover:text-secondary transition-colors flex items-center gap-space-2xs"
                    href="#"
                  >
                    <Sym name="lock_open" className="text-[14px]" />
                    Área do Aluno (Logada)
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-label-lg text-label-lg text-on-surface mb-space-md">
                Segurança &amp; Conformidade
              </h4>
              <ul className="space-y-space-sm font-body-sm text-body-sm">
                <li>
                  <span className="flex items-center gap-space-2xs text-on-surface-variant">
                    <Sym name="shield" className="text-[16px] text-primary" />
                    Criptografia SSL TLS 1.3
                  </span>
                </li>
                <li>
                  <span className="flex items-center gap-space-2xs text-on-surface-variant">
                    <Sym name="bolt" className="text-[16px] text-primary" />
                    Liquidação Pix Bacen SPI
                  </span>
                </li>
                <li>
                  <span className="flex items-center gap-space-2xs text-on-surface-variant">
                    <Sym name="credit_card" className="text-[16px] text-primary" />
                    Protocolo 3D Secure 2.0
                  </span>
                </li>
                <li>
                  <span className="flex items-center gap-space-2xs text-on-surface-variant">
                    <Sym name="policy" className="text-[16px] text-primary" />
                    LGPD Compliance Verified
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-label-lg text-label-lg text-on-surface mb-space-md">
                Meios Instantâneos &amp; Bandeiras
              </h4>
              <div className="grid grid-cols-2 gap-space-xs">
                <div className="flex items-center gap-space-2xs p-space-xs rounded-lg bg-surface-container-low">
                  <Sym name="qr_code_2" className="text-secondary text-[20px]" />
                  <span className="font-label-sm text-label-sm text-on-surface">Pix SPI</span>
                </div>
                <div className="flex items-center gap-space-2xs p-space-xs rounded-lg bg-surface-container-low">
                  <Sym name="security" className="text-primary text-[20px]" />
                  <span className="font-label-sm text-label-sm text-on-surface">Bacen Auth</span>
                </div>
                <div className="flex items-center gap-space-2xs p-space-xs rounded-lg bg-surface-container-low">
                  <Sym name="contactless" className="text-tertiary text-[20px]" />
                  <span className="font-label-sm text-label-sm text-on-surface">NFC / Wallet</span>
                </div>
                <div className="flex items-center gap-space-2xs p-space-xs rounded-lg bg-surface-container-low">
                  <Sym name="lock" className="text-on-surface-variant text-[20px]" />
                  <span className="font-label-sm text-label-sm text-on-surface">256-Bit SSL</span>
                </div>
              </div>
            </div>
          </div>
          <div className="pt-space-xl flex flex-col sm:flex-row items-center justify-between gap-space-md">
            <p className="font-label-sm text-label-sm text-outline">
              © 2025 Storeo Unified Commerce. Todos os direitos reservados. Liquidação via Sistema
              de Pagamentos Instantâneos (SPI).
            </p>
            <div className="flex items-center gap-space-lg font-label-sm text-label-sm text-outline">
              <a className="hover:text-on-surface transition-colors" href="#">
                Privacidade
              </a>
              <a className="hover:text-on-surface transition-colors" href="#">
                Termos de Venda
              </a>
              <a className="hover:text-on-surface transition-colors" href="#">
                Certificados SSL
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
